import { observable, runInAction } from 'mobx';
import { CustomerGeneral, CustomerModel, ICustomerGeneralReportServices } from 'services/Main/customerGeneralReport_services';
import { DataResponse } from 'services/response';

export type CustomerGeneralReportStore = {
  dataReport: DataResponse<CustomerGeneral[]>

  listCustomer: DataResponse<CustomerModel[]>
};

export interface ICustomerGeneralReportPresenter {
  createStore(): CustomerGeneralReportStore;
  // báo cáo tổng hợp khách hàng
  getDataReport(store: CustomerGeneralReportStore, data: object): Promise<void>
  // lấy danh sách khách hàng
  getListCustomer(store: CustomerGeneralReportStore, data: object): Promise<void>

  exportExcel(data: object): Promise<void>

}

export function createCustomerGeneralReportPresenter({ customerGeneralReportServices }: { customerGeneralReportServices: ICustomerGeneralReportServices }): ICustomerGeneralReportPresenter {
  return {
    createStore: (): CustomerGeneralReportStore =>
      observable({
        dataReport: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },

        listCustomer: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        }
      }),
    // // Hàm lấy data báo cáo Chiến dịch event
    getDataReport: async (store, dataSearch) => {
      try {
        const result = await customerGeneralReportServices.getDataDetail(dataSearch);
        runInAction(() => {
          store.dataReport.data = result.data;
          store.dataReport.isSuccess = result.isSuccess;
          store.dataReport.message = result.message;
          store.dataReport.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh sách khách hàng
    getListCustomer: async (store, dataSearch) => {
      try {
        const result = await customerGeneralReportServices.getListCustomer(dataSearch);
        runInAction(() => {
          store.listCustomer.data = result.data;
          store.listCustomer.isSuccess = result.isSuccess;
          store.listCustomer.message = result.message;
          store.listCustomer.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy danh sách khách hàng
    exportExcel: async (dataSearch) => {
      try {
        await customerGeneralReportServices.exportExcel(dataSearch);
      } catch (error) {
        console.log(error);
      }
    },
  };
}
